import React from 'react';
import style from './ChatLayout.module.less';

function ChatLayout({
  children,
  avatar,
  inputBox,
  bubbles,
  mode = 'default',
}: {
  children?: React.ReactNode;
  avatar: React.ReactNode;
  inputBox: React.ReactNode;
  bubbles: React.ReactNode;
  mode?: 'default' | 'split';
}) {
  // 左右分栏布局（layout4）
  if (mode === 'split') {
    return (
      <>
        <div className={style.chatRootSplit}>
          {/* 左侧：数字人 */}
          <div className={style.leftPanel}>
            <div className={style.avatarWrapper}>{avatar}</div>
          </div>

          {/* 右侧：对话记录 + 工具栏 */}
          <div className={style.rightPanel}>
            <div className={style.conversationWrapper}>{bubbles}</div>
            <div className={style.controlsWrapper}>{inputBox}</div>
          </div>
        </div>

        {/* children 渲染在 grid 外部 */}
        {children}
      </>
    );
  }

  // 原有默认布局
  return (
    <div className={style.chatRoot}>
      <div className={style.main}>
        <div className={style.bubbles}>{bubbles}</div>
      </div>
      {/* 数字人容器现在由AvatarContainer统一管理 */}
      {avatar}
      <div className={style.footer}>{inputBox}</div>
      {children}
    </div>
  );
}

export default ChatLayout;
